/* eslint-disable */
(function (window, document, $, app) {
	function getCity(retailersContent, mapDiv, loader, searchInput, fade, onComplete) {
		$("#distance").val('')
		let city = $("#retailers_search_value").val();
		if (city === '') {
			return;
		}
		// let lang_code = $("#lang_code").val();
		if (app.currentGetCityRequest) {
			app.currentGetCityRequest.abort();
		}
		app.currentGetCityRequest = $.ajax({
			type: "get",
			dataType: "json",
			url: window.agroAjax.ajaxurl,
			data: {
				action: "retailers_pagination",
				city,
				ajax: true,
				page: 0
			},
			beforeSend: function () {
				loader.addClass('active');
				retailersContent.fadeOut();
			},
			success: function (response) {
				if (response.error) {
				} else {
					let city = searchInput.val();
					let url = window.location.href;
					let url_array = url.split("/");
					let new_url = "/" + url_array[3] + "/?city=" + city;

					window.history.pushState("", "", new_url);
					retailersContent.html(response.success.html);
					mapDiv.data('data-map', response.success.gmap);
					mapDiv.data('shown-ids', response.success.shownids);
					mapDiv.data('page', 1);
					app.initContactMap(response.success.gmap, document.querySelector('#main_retailers_map'), false);
					if ($('.terran-retailers-scroll-wrap').hasClass('noMoreResult')) {
						$('.terran-retailers-scroll-wrap').removeClass('noMoreResult');
					}
					$('#terran-retailers-more').removeClass('inactive');
				}
			},
			error: function (response) {
				loader.removeClass('active');
				if (!retailersContent.last().hasClass('no-result')) {
					retailersContent.html(response.error);
				}
			},
			complete: function () {
				if (fade) {
					retailersContent.fadeIn();
				}
				loader.removeClass('active');
				if (onComplete) {
					onComplete();
				}
			}
		});
	}

	function loadOnScroll(retailersScroll, retailersContent, mapDiv, loader, search_city, onComplete) {
		let page = mapDiv.data('page');
		let search = search_city.val();
		let shown_ids = mapDiv.data('shown-ids');
		let city = null;
		if ($("#retailers_search_value").length) {
			city = $("#retailers_search_value").val();
		}
		let latitude = mapDiv.data('latitude') || null;
		let longitude = mapDiv.data('longitude') || null;
		let distance = $('#distance').val() || null;
		// let lang_code = $("#lang_code").val();
		$.ajax({
			type: "get",
			dataType: "json",
			url: window.agroAjax.ajaxurl,
			data: {
				action: "retailers_pagination",
				page,
				search,
				shown_ids,
				city,
				ajax: true,
				latitude,
				longitude,
				distance
			},
			beforeSend: function () {
				retailersContent.addClass('active');
				loader.addClass('active');
			},
			success: function (response) {
				if (response.error) {
					$('.terran-retailers-scroll-wrap').addClass('noMoreResult');
					$('#terran-retailers-more').addClass('v-hidden')
					loader.removeClass('active');
					if (!retailersContent.last().hasClass('no-result')) {
						retailersContent.append(response.error.html);
					}
				} else {
					mapDiv.data('page', page + 1);
					retailersContent.append(response.success.html);
				}
			},
			error: function () {
				retailersContent.removeClass('active');
				loader.removeClass('active');
			},
			complete: function () {
				loader.removeClass('active');
				if (onComplete) {
					onComplete();
				}
			}
		});
	}

	function getRetailersByPosition(retailersContent, mapDiv, loader, fade, onComplete)  {
		if (!navigator.geolocation) {
				console.log('Geolocation is not supported by this browser.');
		}

		navigator.geolocation.getCurrentPosition(function (position) {
			const distance = $('#distance').val() || null;
			// let lang_code = $("#lang_code").val();
			$.ajax({
				type: 'get',
				dataType: 'json',
				url: window.agroAjax.ajaxurl,
				data: {
					action: 'retailers_pagination',
					ajax: true,
					page: 0,
					// lang_code: lang_code,
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,
					distance: distance,
				},
				beforeSend: function () {
					retailersContent.addClass('active');
					loader.addClass('active');
				},
				success: function (response) {
					if (response.error) {
						$('.terran-retailers-scroll-wrap').addClass('noMoreResult');
						loader.removeClass('active');

						if (!retailersContent.children().last().hasClass('no-result')) {
							retailersContent.append(response.error.html);
						}
					} else {
						mapDiv.data('page', 1);
						mapDiv.data('data-map', response.success.gmap);
						mapDiv.data('shown-ids', response.success.shownids);
						mapDiv.data('latitude', position.coords.latitude);
						mapDiv.data('longitude', position.coords.longitude);
						mapDiv.data('distance', distance);

						app.initContactMap(response.success.gmap, document.querySelector('#main_retailers_map'), false);
						if ($('.terran-retailers-scroll-wrap').hasClass('noMoreResult')) {
							$('.terran-retailers-scroll-wrap').removeClass('noMoreResult');
						}
						$('#terran-retailers-more').removeClass('inactive');

						retailersContent.html(response.success.html);
					}
				},
				error: function () {
					retailersContent.removeClass('active');
					loader.removeClass('active');
				},
				complete: function () {
					loader.removeClass('active');
					if (onComplete) {
						onComplete();
					}
				}
			});
		});

	}

	$(() => {

		const $mapDiv = $('#main_retailers_map');

		if (!$mapDiv) {
			return;
		}

		const $retailersScroll = $('.terran-retailers-scroll-wrap');
		const $retailersContent = $('.terran-retailers-scroll');
		const $loaderCity = $('.terran__loader--retailers-city');
		const $loaderMore = $('.terran__loader--retailers-more');
		const $loaderMobile = $('.terran__loader--retailers-mobile');
		const $mobileMoreBtn = $('#terran-retailers-more');
		const $search_city = $('#search_city');
		const $search_value_input = $('#retailers_search_value');
		const locationTrigger = $('#currentLocation');
		const distanceTrigger = $('#distance');

		if (!$retailersContent.length) {
			return;
		}
		let doingAjax = false;

		$mobileMoreBtn
			.off('click.mobileMoreBtnClick')
			.on('click.mobileMoreBtnClick', function (e) {
				e.preventDefault();
				if ($retailersContent.find('.no-result').length === 0) {
					loadOnScroll($retailersScroll, $retailersContent, $mapDiv, $loaderMobile, $search_city, onComplete);
				}
			});

		$retailersScroll.scroll(function () {
			if (!doingAjax && ($retailersScroll.scrollTop() >= ($retailersContent.height() - $retailersScroll.height() + 150))) {
				doingAjax = true;
				if ($retailersContent.find('.no-result').length === 0) {
					loadOnScroll($retailersScroll, $retailersContent, $mapDiv, $loaderMore, $search_city, onComplete);
				}
			}
		});

		$search_value_input.selectize({});
		$search_value_input.on('change', function (event) {
			if ($(this).val()) {
				if (distanceTrigger.length) {
					distanceTrigger[0].selectize.clear();
				}
				let $loader = window.innerWidth <= 991 ? $loaderMobile : $loaderCity;
				getCity($retailersContent, $mapDiv, $loader, $search_value_input, true, onComplete);
			}
		});

		locationTrigger.off('click.Location').on('click.Location', function (event) {
			event.preventDefault();
			if (distanceTrigger.val() === '') {
				distanceTrigger[0].selectize.setValue('50', true);
			}
			$search_value_input[0].selectize.clear();
			let url = window.location.href;
			let url_array = url.split("/");
			let new_url = "/" + url_array[3] + "/";
			window.history.pushState("", "", new_url);
			let $loader = window.innerWidth <= 991 ? $loaderMobile : $loaderCity;
			getRetailersByPosition($retailersContent, $mapDiv, $loader, true);
		});

		distanceTrigger.selectize({});
		distanceTrigger.off('change.Location').on('change.Location', function () {
			if ($(this).val()) {
				$search_value_input[0].selectize.clear();
				let url = window.location.href;
				let url_array = url.split("/");
				let new_url = "/" + url_array[3] + "/";
				window.history.pushState("", "", new_url);
				let $loader = window.innerWidth <= 991 ? $loaderMobile : $loaderCity;
				getRetailersByPosition($retailersContent, $mapDiv, $loader, true);
			}
		});

		function onComplete() {
			doingAjax = false;
		}
	});
})(window, document, jQuery, Yco);
/* eslint-enable */



// WEBPACK FOOTER //
// ./assets/scripts/retailers-scroll.js